'use client';

import { useTranslations } from 'next-intl';
import { BodyDefault, Checkbox, Tooltip } from '@terra/ui-design-system';
import { ListPageDateRangeFilter } from '../common/ListPageDateRangeFilter';
import {
  ListPageAdvancedFilterField,
  ListPageAdvancedFilters,
} from '../common/ListPageAdvancedFilters';

type AssetsAdvancedFiltersProps = {
  updatedStartDate: Date | null;
  setUpdatedStartDate: (date: Date | null) => void;
  updatedEndDate: Date | null;
  setUpdatedEndDate: (date: Date | null) => void;
  showWithCodeGraphFilter: boolean;
  withCodeGraph: boolean;
  setWithCodeGraph: (withCodeGraph: boolean) => void;
};

export function AssetsAdvancedFilters({
  updatedStartDate,
  setUpdatedStartDate,
  updatedEndDate,
  setUpdatedEndDate,
  showWithCodeGraphFilter,
  withCodeGraph,
  setWithCodeGraph,
}: AssetsAdvancedFiltersProps) {
  const tProxyAssets = useTranslations('proxy.assets');
  const tFilters = useTranslations('proxy.filters');

  return (
    <ListPageAdvancedFilters>
      <ListPageAdvancedFilterField>
        <ListPageDateRangeFilter
          label={tFilters('updatedAt')}
          startDate={updatedStartDate}
          endDate={updatedEndDate}
          onStartDateChange={setUpdatedStartDate}
          onEndDateChange={setUpdatedEndDate}
        />
      </ListPageAdvancedFilterField>
      {showWithCodeGraphFilter ? (
        <ListPageAdvancedFilterField>
          <Tooltip title={tProxyAssets('withCodeGraphTooltip')}>
            <Checkbox
              size="sm"
              checked={withCodeGraph}
              onCheckedChange={(details) =>
                setWithCodeGraph(details.checked === true)
              }
            >
              <BodyDefault color="fg.default" whiteSpace="nowrap">
                {tProxyAssets('withCodeGraph')}
              </BodyDefault>
            </Checkbox>
          </Tooltip>
        </ListPageAdvancedFilterField>
      ) : null}
    </ListPageAdvancedFilters>
  );
}
